document.documentElement.classList.remove('no-js');

const money = (cents) => `${new Intl.NumberFormat('he-IL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(cents / 100)} ₪`;

const accessibilityDefaults = { fontSize: 100, contrast: false, links: false, readable: false, motion: false };
function readAccessibilitySettings() {
  try { return { ...accessibilityDefaults, ...JSON.parse(localStorage.getItem('maromAccessibility') || '{}') }; }
  catch (error) { return { ...accessibilityDefaults }; }
}
function applyAccessibilitySettings(settings) {
  const root = document.documentElement;
  root.style.setProperty('--accessibility-font-scale', `${settings.fontSize / 100}`);
  root.classList.toggle('a11y-high-contrast', settings.contrast);
  root.classList.toggle('a11y-highlight-links', settings.links);
  root.classList.toggle('a11y-readable-font', settings.readable);
  root.classList.toggle('a11y-reduce-motion', settings.motion);
  document.querySelectorAll('[data-accessibility-action]').forEach((button) => {
    const action = button.dataset.accessibilityAction;
    if (Object.hasOwn(settings, action)) button.setAttribute('aria-pressed', String(Boolean(settings[action])));
  });
  try { localStorage.setItem('maromAccessibility', JSON.stringify(settings)); } catch (error) { /* Storage is optional. */ }
}
let accessibilitySettings = readAccessibilitySettings();
applyAccessibilitySettings(accessibilitySettings);

function closeDrawers() {
  document.querySelector('[data-mobile-menu]')?.classList.remove('is-open');
  document.querySelector('[data-cart-drawer-shell]')?.classList.remove('is-open');
  const accessibilityPanel = document.querySelector('[data-accessibility-panel]');
  if (accessibilityPanel) accessibilityPanel.hidden = true;
  document.querySelector('[data-accessibility-toggle]')?.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('drawer-open');
}

function openCart() {
  const shell = document.querySelector('[data-cart-drawer-shell]');
  if (!shell) return;
  shell.classList.add('is-open');
  document.body.classList.add('drawer-open');
  shell.querySelector('.cart-drawer')?.focus();
}

async function swapCartSection() {
  const response = await fetch(`${location.pathname}?section_id=cart-drawer`, { headers: { Accept: 'text/html' } });
  if (!response.ok) throw new Error('Cart section request failed');
  const html = await response.text();
  const current = document.querySelector('#shopify-section-cart-drawer');
  if (current) current.outerHTML = html;
  const cart = await fetch('/cart.js').then((result) => result.json());
  document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
  return cart;
}

// Free-gift-with-purchase: the "gift-progress" block in the cart drawer carries the
// threshold and target variant as data attributes so this stays configurable from the
// theme editor without touching JS. The matching Shopify discount only makes the item
// free once it's actually a cart line, so this keeps it in sync as totals change.
const GIFT_PROPERTY_KEY = '_gift';

async function syncGiftItem(cart) {
  const progressEl = document.querySelector('[data-gift-progress]');
  if (!progressEl) return false;
  const thresholdCents = Number(progressEl.dataset.giftThresholdCents || 0);
  const variantId = Number(progressEl.dataset.giftVariantId || 0);
  if (!thresholdCents || !variantId) return false;

  const giftLine = cart.items.find((item) => item.variant_id === variantId && item.properties && item.properties[GIFT_PROPERTY_KEY]);
  const qualifies = cart.total_price >= thresholdCents;

  if (qualifies && !giftLine) {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { [GIFT_PROPERTY_KEY]: 'מתנה על הזמנה מעל הסכום' } }] }),
    });
    return true;
  }

  if (!qualifies && giftLine) {
    const line = cart.items.indexOf(giftLine) + 1;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: 0 }),
    });
    return true;
  }

  return false;
}

async function refreshCart(openAfter = true) {
  const cart = await swapCartSection();
  try {
    const changed = await syncGiftItem(cart);
    if (changed) await swapCartSection();
  } catch (error) { /* Gift sync is best-effort; the cart itself already refreshed. */ }
  if (openAfter) openCart();
}

document.addEventListener('click', async (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const menu = document.querySelector('[data-mobile-menu]');
    menu?.classList.toggle('is-open');
    document.body.classList.toggle('drawer-open');
    toggle.setAttribute('aria-expanded', menu?.classList.contains('is-open') ? 'true' : 'false');
  }

  const quantity = event.target.closest('[data-quantity-change]');
  if (quantity) {
    const input = quantity.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(quantity.dataset.quantityChange));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  const cartOpen = event.target.closest('[data-cart-open]');
  if (cartOpen) { event.preventDefault(); openCart(); }
  if (event.target.closest('[data-cart-close]')) closeDrawers();

  const change = event.target.closest('[data-cart-quantity]');
  if (change) {
    change.disabled = true;
    try {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(change.dataset.line), quantity: Number(change.dataset.cartQuantity) }) });
      await refreshCart();
    } catch (error) { window.location.href = '/cart'; }
  }

  const stickyAdd = event.target.closest('[data-sticky-add]');
  if (stickyAdd) document.querySelector('[data-product-form] [data-add-to-cart]')?.click();

  const policyOpen = event.target.closest('[data-policy-open]');
  if (policyOpen) {
    event.preventDefault();
    const dialog = document.getElementById(policyOpen.dataset.policyOpen);
    if (dialog?.showModal) { dialog.showModal(); document.body.classList.add('drawer-open'); }
  }
  const policyClose = event.target.closest('[data-policy-close]');
  if (policyClose) {
    policyClose.closest('dialog')?.close();
    document.body.classList.remove('drawer-open');
  }

  const accessibilityToggle = event.target.closest('[data-accessibility-toggle]');
  if (accessibilityToggle) {
    const panel = document.querySelector('[data-accessibility-panel]');
    const willOpen = panel?.hidden;
    if (panel) panel.hidden = !willOpen;
    accessibilityToggle.setAttribute('aria-expanded', String(Boolean(willOpen)));
    if (willOpen) panel.querySelector('[data-accessibility-close]')?.focus();
  }
  const accessibilityClose = event.target.closest('[data-accessibility-close]');
  if (accessibilityClose) {
    const panel = document.querySelector('[data-accessibility-panel]');
    if (panel) panel.hidden = true;
    const trigger = document.querySelector('[data-accessibility-toggle]');
    trigger?.setAttribute('aria-expanded', 'false');
    trigger?.focus();
  }
  const accessibilityAction = event.target.closest('[data-accessibility-action]');
  if (accessibilityAction) {
    const action = accessibilityAction.dataset.accessibilityAction;
    if (action === 'font-increase') accessibilitySettings.fontSize = Math.min(130, accessibilitySettings.fontSize + 10);
    else if (action === 'font-decrease') accessibilitySettings.fontSize = Math.max(90, accessibilitySettings.fontSize - 10);
    else if (action === 'reset') accessibilitySettings = { ...accessibilityDefaults };
    else if (Object.hasOwn(accessibilitySettings, action)) accessibilitySettings[action] = !accessibilitySettings[action];
    applyAccessibilitySettings(accessibilitySettings);
  }
});

document.addEventListener('click', (event) => {
  if (event.target.matches('dialog.policy-dialog')) {
    const bounds = event.target.getBoundingClientRect();
    const inside = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
    if (!inside) { event.target.close(); document.body.classList.remove('drawer-open'); }
  }
});

document.addEventListener('close', (event) => {
  if (event.target.matches?.('.policy-dialog')) document.body.classList.remove('drawer-open');
}, true);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('form[action*="/cart/add"]');
  if (!form) return;
  event.preventDefault();
  const submit = form.querySelector('[type="submit"]');
  if (submit) submit.disabled = true;
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
    if (!response.ok) throw new Error('Add to cart failed');
    await refreshCart();
  } catch (error) {
    form.submit();
  } finally {
    if (submit) submit.disabled = false;
  }
});

document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawers(); });

// On load, silently reconcile the free-gift line (e.g. a customer returning with an
// already-qualifying cart) without popping the drawer open.
(async () => {
  try {
    const progressEl = document.querySelector('[data-gift-progress]');
    if (!progressEl) return;
    const cart = await fetch('/cart.js').then((result) => result.json());
    const changed = await syncGiftItem(cart);
    if (changed) await swapCartSection();
  } catch (error) { /* Gift sync is best-effort. */ }
})();

document.querySelectorAll('[data-product-variants]').forEach((json) => {
  const section = document.querySelector('[data-product-section]');
  const form = section?.querySelector('[data-product-form]');
  if (!form) return;
  const variants = JSON.parse(json.textContent);
  const select = form.querySelector('[data-variant-select]');
  const submit = form.querySelector('[data-add-to-cart]');
  const price = section.querySelector('[data-product-price]');
  const inventory = section.querySelector('[data-product-inventory]');
  const sku = section.querySelector('[data-product-sku]');
  const stickyButton = document.querySelector('[data-sticky-add]');
  const stickyPrice = document.querySelector('[data-sticky-price]');
  const comparePrice = section.querySelector('[data-product-compare-price]');
  const saving = section.querySelector('[data-product-saving]');
  const buttonPrice = section.querySelector('[data-button-price]');
  const installmentBox = section.querySelector('[data-installments-count]');
  const installmentPrice = section.querySelector('[data-installment-price]');

  // Option groups are read in Shopify's option order, not DOM order, so the
  // value array always lines up with variant.options.
  const groups = [...form.querySelectorAll('[data-variant-picker] fieldset[data-option-position]')]
    .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
  if (!groups.length) return;

  // Defensive: a group must always carry a selection for variant matching to work.
  groups.forEach((group) => {
    if (!group.querySelector('input:checked')) {
      const first = group.querySelector('input[type="radio"]');
      if (first) first.checked = true;
    }
  });

  const selectedValues = () => groups.map((group) => group.querySelector('input:checked')?.value);
  const matchVariant = (values) => variants.find((item) => item.options.every((value, index) => value === values[index]));

  const stockLabel = (variant) => {
    if (!variant?.available) return 'אזל מהמלאי';
    if (variant.inventory_management && variant.inventory_quantity <= 5) return 'נותרו יחידות אחרונות';
    return 'במלאי';
  };

  // Marks every option value that cannot lead to a purchasable variant, given
  // whatever is selected in the other groups.
  const updateAvailability = (values) => {
    groups.forEach((group, index) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const trial = [...values];
        trial[index] = input.value;
        const candidate = matchVariant(trial);
        input.nextElementSibling?.classList.toggle('is-unavailable', !candidate?.available);
      });
    });
  };

  const setLabel = (element, text) => {
    if (!element) return;
    const inner = element.querySelector('span');
    if (inner) inner.textContent = text;
    else element.textContent = text;
  };

  const render = () => {
    const values = selectedValues();
    updateAvailability(values);

    groups.forEach((group) => {
      const selectedLabel = group.querySelector('[data-option-selected]');
      if (selectedLabel) selectedLabel.textContent = group.querySelector('input:checked')?.value || '';
    });

    const variant = matchVariant(values);
    const available = Boolean(variant?.available);
    const buttonText = variant ? (available ? 'הוספה לסל' : 'אזל מהמלאי') : 'הצירוף אינו זמין';

    if (select && variant) select.value = variant.id;
    if (submit) { submit.disabled = !available; setLabel(submit, buttonText); }
    if (stickyButton) { stickyButton.disabled = !available; stickyButton.textContent = buttonText; }
    if (inventory) inventory.textContent = variant ? stockLabel(variant) : 'הצירוף אינו זמין';
    if (!variant) return;

    if (price) price.textContent = money(variant.price);
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    if (buttonPrice) buttonPrice.textContent = money(variant.price);
    if (installmentBox && installmentPrice) installmentPrice.textContent = money(Math.round(variant.price / Number(installmentBox.dataset.installmentsCount || 1)));
    if (comparePrice) {
      comparePrice.hidden = !(variant.compare_at_price > variant.price);
      comparePrice.textContent = variant.compare_at_price ? money(variant.compare_at_price) : '';
    }
    if (saving) {
      const amount = (variant.compare_at_price || 0) - variant.price;
      saving.hidden = amount <= 0;
      saving.textContent = amount > 0 ? `חיסכון ${money(amount)}` : '';
    }
    if (sku) { sku.hidden = !variant.sku; sku.textContent = variant.sku ? `מקט"ט: ${variant.sku}` : ''; }
    if (variant.featured_media?.id) section.querySelector(`[data-product-thumbnail="${variant.featured_media.id}"]`)?.click();
    if (history.replaceState) history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`);
  };

  form.addEventListener('change', (event) => {
    if (event.target.matches('input[name^="options"]')) render();
  });

  updateAvailability(selectedValues());
});

document.querySelectorAll('[data-product-thumbnail]').forEach((thumbnail) => {
  thumbnail.addEventListener('click', () => {
    const section = thumbnail.closest('[data-product-section]');
    if (!section) return;
    section.querySelectorAll('[data-product-thumbnail]').forEach((item) => {
      item.classList.toggle('is-active', item === thumbnail);
      item.setAttribute('aria-current', item === thumbnail ? 'true' : 'false');
    });
    section.querySelectorAll('[data-media-id]').forEach((media) => {
      const active = media.dataset.mediaId === thumbnail.dataset.productThumbnail;
      media.hidden = !active;
      media.classList.toggle('is-active', active);
      if (!active) media.querySelector('video')?.pause();
    });
  });
});

document.querySelectorAll('[data-product-share]').forEach((button) => {
  button.addEventListener('click', async () => {
    const data = { title: button.dataset.shareTitle, url: button.dataset.shareUrl };
    try {
      if (navigator.share) await navigator.share(data);
      else { await navigator.clipboard.writeText(data.url); button.classList.add('is-copied'); button.querySelector('span:last-child').textContent = 'הקישור הועתק'; setTimeout(() => { button.classList.remove('is-copied'); button.querySelector('span:last-child').textContent = 'שתפי את המוצר'; }, 2200); }
    } catch (error) { /* The customer may cancel the native share sheet. */ }
  });
});

document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
  if (section.querySelector('.product-card')) return;
  try {
    const response = await fetch(section.dataset.url);
    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const replacement = documentFragment.querySelector('[data-product-recommendations]');
    if (replacement?.querySelector('.product-card')) section.outerHTML = replacement.outerHTML;
  } catch (error) { /* Recommendations are optional. */ }
});

if (location.hash.startsWith('#policy-')) {
  const policy = document.querySelector(location.hash);
  if (policy?.showModal) policy.showModal();
}

document.querySelectorAll('[data-size-guide-dialog]').forEach((dialog) => {
  const closeDialog = () => { if (dialog.close) dialog.close(); else dialog.removeAttribute('open'); document.body.classList.remove('drawer-open'); };
  document.querySelectorAll(`[href="#${dialog.id}"][data-size-guide-open]`).forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault(); if (dialog.showModal) dialog.showModal(); else dialog.setAttribute('open', ''); document.body.classList.add('drawer-open');
  }));
  dialog.querySelector('[data-size-guide-close]')?.addEventListener('click', closeDialog);
  dialog.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
  dialog.addEventListener('close', () => document.body.classList.remove('drawer-open'));
  dialog.querySelectorAll('[data-size-tab]').forEach((button) => button.addEventListener('click', () => {
    dialog.querySelectorAll('[data-size-tab]').forEach((item) => { const active = item === button; item.classList.toggle('is-active', active); item.setAttribute('aria-selected', String(active)); });
    dialog.querySelectorAll('[data-size-panel]').forEach((panel) => { const active = panel.dataset.sizePanel === button.dataset.sizeTab; panel.hidden = !active; panel.classList.toggle('is-active', active); });
  }));

  let ringMethod = 'diameter';
  dialog.querySelectorAll('[data-ring-method]').forEach((button) => button.addEventListener('click', () => {
    ringMethod = button.dataset.ringMethod; dialog.querySelectorAll('[data-ring-method]').forEach((item) => item.classList.toggle('is-active', item === button));
    const label = dialog.querySelector('[data-ring-label]'); const input = dialog.querySelector('[data-ring-input]'); const instruction = dialog.querySelector('[data-ring-instruction]');
    if (ringMethod === 'diameter') { label.textContent = 'קוטר פנימי במ"מ'; input.min = '12'; input.max = '25'; input.placeholder = 'לדוגמה: 17.8'; instruction.textContent = 'מדדי את הקוטר הפנימי של טבעת שמתאימה לך'; }
    else { label.textContent = 'היקף האצבע במ"מ'; input.min = '40'; input.max = '75'; input.placeholder = 'לדוגמה: 56'; instruction.textContent = 'כרכי רצועת נייר דקה סביב בסיס האצבע וסמני את נקודת המפגש'; }
    input.value = ''; dialog.querySelector('[data-ring-result]').hidden = true;
  }));

  const applySuggestedSize = (size) => {
    const section = document.querySelector('[data-product-section]');
    const candidates = String(size).split('|');
    const inputs = [...(section?.querySelectorAll('.variant-option--size input[type="radio"]') || [])];
    const input = inputs.find((item) => candidates.some((candidate) => item.value.includes(candidate)));
    if (!input) return false;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    closeDialog();
    input.closest('.variant-option')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  };
  const resultMarkup = (title, note, size) => `<strong>${title}</strong><span>${note}</span><button type="button" data-apply-size="${size}">בחרי מידה זו במוצר</button>`;
  dialog.querySelector('[data-ring-calculate]')?.addEventListener('click', () => {
    const value = Number(dialog.querySelector('[data-ring-input]').value); const result = dialog.querySelector('[data-ring-result]'); const valid = ringMethod === 'diameter' ? value >= 12 && value <= 25 : value >= 40 && value <= 75;
    if (!valid) { result.innerHTML = '<strong>המדידה אינה בטווח הרגיל</strong><span>בדקי שהזנת מילימטרים ונסי שוב.</span>'; result.hidden = false; return; }
    const circumference = ringMethod === 'diameter' ? value * Math.PI : value; const europeanSize = Math.round(circumference); const israeliSize = europeanSize - 40;
    const usSizes = { 47: '4', 48: '4.5', 49: '5', 50: '5.25', 51: '5.5', 52: '6', 53: '6.25', 54: '7', 55: '7.25', 56: '7.5', 57: '8', 58: '8.25', 59: '8.5', 60: '9', 61: '9.25', 62: '9.5', 63: '10.25', 64: '10.5', 65: '11', 66: '11.5', 67: '12' };
    const usNote = usSizes[europeanSize] ? ` · מידה אמריקאית: ${usSizes[europeanSize]}` : '';
    result.innerHTML = resultMarkup(`המידה האירופית שלך: ${europeanSize}`, `היקף משוער: ${circumference.toFixed(1)} מ"מ · מידה ישראלית מקבילה: ${israeliSize}${usNote}. אם את בין מידות, מומלץ לבחור במידה הגדולה יותר.`, europeanSize); result.hidden = false;
  });
  dialog.querySelector('[data-bracelet-calculate]')?.addEventListener('click', () => {
    const wrist = Number(dialog.querySelector('[data-bracelet-input]').value); const result = dialog.querySelector('[data-bracelet-result]');
    if (wrist < 10 || wrist > 30) { result.innerHTML = '<strong>בדקי את המדידה</strong><span>יש להזין את היקף היד בסנטימטרים.</span>'; result.hidden = false; return; }
    const size = Math.round((wrist + Number(dialog.querySelector('[data-bracelet-fit]').value)) * 2) / 2; result.innerHTML = resultMarkup(`אורך הצמיד המומלץ: ${size} ס"מ`, 'ההמלצה כוללת מרווח נוחות בהתאם לסגנון שבחרת.', size); result.hidden = false;
  });
  dialog.querySelectorAll('[data-necklace-size]').forEach((button) => button.addEventListener('click', () => {
    dialog.querySelectorAll('[data-necklace-size]').forEach((item) => item.classList.toggle('is-active', item === button)); const size = button.dataset.necklaceSize; const label = button.dataset.necklaceLabel; const result = dialog.querySelector('[data-necklace-result]'); result.innerHTML = resultMarkup(`בחרת שרשרת באורך ${label}`, 'אפשר להחיל את האורך ישירות אם הוא זמין בדגם הזה.', size); result.hidden = false;
  }));
  dialog.addEventListener('click', (event) => { const apply = event.target.closest('[data-apply-size]'); if (apply && !applySuggestedSize(apply.dataset.applySize)) { apply.textContent = 'המידה אינה זמינה בדגם הזה — נשמח לעזור ב—WhatsApp'; apply.disabled = true; } });
});
